import React, { Fragment } from 'react'
import { Card } from 'antd'
import List from '../List'
import Header from '../Header'
import { FormattedMessage } from 'react-intl'
import DispatchDetail from '../DispatchDetail'


const ListView = (props) => {
    const { id, model } = props.match.params
    
    const breadcrumbList = [
        { title: <FormattedMessage id={'Breadcrumb.home'} />, href: '#/model' },
        { title: <FormattedMessage id={`Model.${model}.list`} />, href: `#/model/${model}` },
        
    ]

        if(model === 'quote' || model === 'arrivalnotification'){
            return (
                <Fragment>
                    <Card style={{ marginBottom: 20 }}>
                        <List model={model} id={id} showAdd={true} />
                    </Card>
                    {props.selected && <DispatchDetail model="dispatch" id={props.selected} />}
                </Fragment>
            )
        }else{
            return (
                <Fragment>
                    <Header breadcrumbList={breadcrumbList} title={<FormattedMessage id={`Model.${model}.list`} />}/>
                    <Card style={{ marginBottom: 20 }}>
                        <List model={model} id={id} showAdd={model !== 'vehicletype'} />
                    </Card>
                    {props.selected && <DispatchDetail model="dispatch" id={props.selected} />}
                </Fragment>
                
            )
        }
    
}

export default ListView



// WEBPACK FOOTER //
// ./src/containers/ListView/index.js